import { Markup } from '@/components/Markup';
import { TwitterTheme } from '@/components/Twitter/theme';
import { GenericSlot } from 'base/components/GenericSlot';

export const Twitter = GenericSlot({ as: Markup, theme: TwitterTheme });
